






import { Component, Vue, Prop } from 'vue-property-decorator'
import WebsiteBody from '../../components/WebsiteBody/index.vue'
import downloadIcon from '../../assets/images/download-icon.png'
import Bus from '../../utils/bus'
@Component({
  components: { WebsiteBody },
})
export default class PolicyComponent extends Vue {
  private info = {
    icon: downloadIcon,
    title: '资料下载',
    type: 'DATA_DOWNLOAD',
    list: [],
    total: 0,
  }
  private form = {
    page: 1,
    limit: 15,
  }
  private loading = true
  created() {
    Bus.$on('dataDownload/currentChange', (val) => {
      this.currentChange(val)
    })
    Bus.$on('dataDownload/prevClick', () => {
      this.prevClick()
    })
    Bus.$on('dataDownload/nextClick', () => {
      this.nextClick()
    })
    this.getNewsList()
  }
  beforeDestroy() {
    const arr = ['currentChange', 'prevClick', 'nextClick']
    arr.map((v) => Bus.$off(v))
  }
  // 新闻列表
  async getNewsList() {
    this.loading = true
    const res = await this.$axios('getNewsList', {
      page: this.form.page,
      limit: 15,
      isPublished: true,
      type: 'DATA_DOWNLOAD',
    })
    this.info.list = res.data.data.list
    this.info.total = res.data.data.total
    this.loading = false
  }
  // currentPage 改变时会触发
  private currentChange(val) {
    this.form.page = val
    this.getNewsList()
  }
  private prevClick() {
    this.form.page--
    this.getNewsList()
  }
  private nextClick() {
    this.form.page++
    this.getNewsList()
  }
}
